module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wz"
    }
  }, [_c('header', {
    staticClass: "am-topbar"
  }, [_c('OffCanvas', {
    staticClass: "meun"
  }, [_vm._v("边侧栏")]), _vm._v(" "), _c('div', {
    staticClass: "logo-wrapper"
  }, [(this.ggtitle.hasOwnProperty(_vm.$route.params.ret)) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.ggtitle[_vm.$route.params.ret]))]) : _vm._e(), _vm._v(" "), (this.tzzjytitle.hasOwnProperty(_vm.$route.params.ret)) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.tzzjytitle[_vm.$route.params.ret]) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.ret === 'zcgl') ? _c('div', {
    staticClass: "title"
  }, [_vm._v("资产管理公告\n      ")]) : _vm._e(), _vm._v(" "), (!this.ggtitle.hasOwnProperty(_vm.$route.params.ret) &&
    !this.tzzjytitle.hasOwnProperty(_vm.$route.params.ret) &&
    _vm.$route.params.ret != 'zcgl') ? _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        常见问题\n      ")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.wz)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back"
  }, [(this.ggtitle.hasOwnProperty(_vm.$route.params.ret)) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'gg',
        params: {
          nr: _vm.$route.params.ret
        }
      }
    }
  }, [_vm._v("返回列表\n    ")]) : _vm._e(), _vm._v(" "), (this.tzzjytitle.hasOwnProperty(_vm.$route.params.ret)) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'tzzjy',
        params: {
          nr: _vm.$route.params.ret
        }
      }
    }
  }, [_vm._v("返回列表\n    ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.ret === 'zcgl') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'zcgl',
        params: {
          nr: 'gglist'
        }
      }
    }
  }, [_vm._v("返回列表\n    ")]) : _vm._e(), _vm._v(" "), (!this.ggtitle.hasOwnProperty(_vm.$route.params.ret) &&
    !this.tzzjytitle.hasOwnProperty(_vm.$route.params.ret) &&
    _vm.$route.params.ret !== 'zcgl') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'cjwt'
      }
    }
  }, [_vm._v("\n      返回列表\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('ICP')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ec43da5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/wz/wz.vue
// module id = 874
// module chunks = 2